import { Input } from "collections";
import React, { Dispatch } from "react";
import { useTranslation } from "utilities/i18n";
import { GroupMutationData } from "./UserGroupMutationForm";

export const GroupInput: React.FC<{
  groupData: GroupMutationData;
  setGroupData: Dispatch<React.SetStateAction<GroupMutationData>>;
}> = ({ groupData, setGroupData }) => {
  const { t } = useTranslation();
  return (
    <div className="half-width pv-1">
      <Input
        name="name"
        label={t("GROUP_NAME")}
        onChange={event => {
          setGroupData({ ...groupData, name: event.target.value });
        }}
        value={groupData.name}
      />
    </div>
  );
};
